import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { getOrganizationCoursesQuery } from "AppComponents/SharedEntities/CustomEntities/modules/MembersQueries";
import _ from "lodash";

const useServerFilteredCourses = ({ organizationId, searchText }) => {
  const { data, loading, error } = useQuery(getOrganizationCoursesQuery, {
    variables: {
      id: organizationId,
      filters: { searchText },
    },
    fetchPolicy: "cache-and-network",
    skip: !organizationId || !searchText,
    context: {
      useHttpLink: true,
    },
  });

  const courses = useMemo(
    () => _.get(data, "node.courses.edges", []).map(e => e.node),
    [data]
  );

  return { courses, loading, error };
};

export default useServerFilteredCourses;
